import VerticalNavTabsComponent from './VerticalNavTabs'
import Link from './Link'

const VerticalNavTabs = VerticalNavTabsComponent
VerticalNavTabs.Link = Link

export default VerticalNavTabs
